// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useAuth } from "./Utility/AuthProvider";
// import APICall from "./Utility/APICall";
// import { paths } from "./Utility/Constants";

// const AuthPage = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { login } = useAuth();

//   // Auth flow states
//   const [authStep, setAuthStep] = useState("login"); // 'login' | 'otp'
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState("");

//   // Form data
//   const [phoneNumber, setPhoneNumber] = useState("");
//   const [otp, setOtp] = useState(["", "", "", "", "", ""]);
//   const [sessionId, setSessionId] = useState("");
//   const [resendTimer, setResendTimer] = useState(0);

//   // Refs for OTP inputs
//   const otpRefs = useRef([]);
//   const resendTimerRef = useRef(null);

//   // Redirect path for after successful auth
//   const redirectPath = location.state?.from?.pathname || "/dashboard";

//   useEffect(() => {
//     // Cleanup timer on unmount
//     return () => {
//       if (resendTimerRef.current) {
//         clearInterval(resendTimerRef.current);
//       }
//     };
//   }, []);

//   useEffect(() => {
//     // Handle resend timer
//     if (resendTimer > 0) {
//       resendTimerRef.current = setTimeout(() => {
//         setResendTimer(resendTimer - 1);
//       }, 1000);
//     }
//     return () => {
//       if (resendTimerRef.current) {
//         clearTimeout(resendTimerRef.current);
//       }
//     };
//   }, [resendTimer]);

//   const validatePhoneNumber = (phone) => {
//     const phoneRegex = /^[6-9]\d{9}$/;
//     return phoneRegex.test(phone);
//   };

//   const handleSendOTP = async (e) => {
//     e.preventDefault();

//     if (!validatePhoneNumber(phoneNumber)) {
//       setError("Please enter a valid 10-digit mobile number");
//       return;
//     }

//     setIsLoading(true);
//     setError("");

//     try {
//       const response = await APICall("POST", paths.user.sendOTP, {
//         mobile: phoneNumber,
//       });

//       if (response.success) {
//         setSessionId(response.session_id);
//         setAuthStep("otp");
//         setResendTimer(30);
//         setError("");

//         // Focus first OTP input
//         setTimeout(() => {
//           otpRefs.current[0]?.focus();
//         }, 100);
//       } else {
//         setError(response.message || "Failed to send OTP. Please try again.");
//       }
//     } catch (error) {
//       console.error("Send OTP error:", error);
//       setError("Network error. Please check your connection and try again.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleOTPChange = (index, value) => {
//     // Only allow numeric input
//     if (!/^\d*$/.test(value)) return;

//     const newOtp = [...otp];
//     newOtp[index] = value;
//     setOtp(newOtp);

//     // Auto-focus next input
//     if (value && index < 5) {
//       otpRefs.current[index + 1]?.focus();
//     }

//     // Auto-submit when all fields are filled
//     if (newOtp.every((digit) => digit !== "") && newOtp.join("").length === 6) {
//       handleVerifyOTP(newOtp.join(""));
//     }
//   };

//   const handleOTPKeyDown = (index, e) => {
//     // Handle backspace
//     if (e.key === "Backspace" && !otp[index] && index > 0) {
//       otpRefs.current[index - 1]?.focus();
//     }
//   };

//   const handleVerifyOTP = async (otpValue = null) => {
//     const otpToVerify = otpValue || otp.join("");

//     if (otpToVerify.length !== 6) {
//       setError("Please enter the complete 6-digit OTP");
//       return;
//     }

//     setIsLoading(true);
//     setError("");

//     try {
//       const response = await APICall("POST", paths.auth.verifyOTP, {
//         mobile: phoneNumber,
//         otp: otpToVerify,
//         session_id: sessionId,
//       });

//       if (response.success) {
//         // Store auth data
//         await login(response.token, response.user);

//         // Navigate to intended destination
//         navigate(redirectPath, { replace: true });
//       } else {
//         setError(response.message || "Invalid OTP. Please try again.");
//         // Clear OTP inputs on error
//         setOtp(["", "", "", "", "", ""]);
//         otpRefs.current[0]?.focus();
//       }
//     } catch (error) {
//       console.error("Verify OTP error:", error);
//       setError("Network error. Please check your connection and try again.");
//       setOtp(["", "", "", "", "", ""]);
//       otpRefs.current[0]?.focus();
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleResendOTP = async () => {
//     if (resendTimer > 0) return;

//     setIsLoading(true);
//     setError("");

//     try {
//       const response = await APICall("POST", paths.auth.sendOTP, {
//         mobile: phoneNumber,
//       });

//       if (response.success) {
//         setSessionId(response.session_id);
//         setResendTimer(30);
//         setError("");
//         setOtp(["", "", "", "", "", ""]);
//         otpRefs.current[0]?.focus();
//       } else {
//         setError(response.message || "Failed to resend OTP. Please try again.");
//       }
//     } catch (error) {
//       console.error("Resend OTP error:", error);
//       setError("Network error. Please check your connection and try again.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleBackToLogin = () => {
//     setAuthStep("login");
//     setOtp(["", "", "", "", "", ""]);
//     setError("");
//     setSessionId("");
//     setResendTimer(0);
//   };

//   const renderLoginForm = () => (
//     <div className="w-full max-w-md">
//       <div className="text-center mb-8">
//         <h1 className="text-3xl font-bold text-gray-900 mb-2">Welcome Back</h1>
//         <p className="text-gray-600">Enter your mobile number to continue</p>
//       </div>

//       <form onSubmit={handleSendOTP} className="space-y-6">
//         <div>
//           <label
//             htmlFor="phone"
//             className="block text-sm font-medium text-gray-700 mb-2"
//           >
//             Mobile Number
//           </label>
//           <div className="relative">
//             <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">
//               +91
//             </span>
//             <input
//               id="phone"
//               type="tel"
//               value={phoneNumber}
//               onChange={(e) =>
//                 setPhoneNumber(e.target.value.replace(/\D/g, "").slice(0, 10))
//               }
//               placeholder="Enter 10-digit mobile number"
//               className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
//               disabled={isLoading}
//               maxLength={10}
//               required
//             />
//           </div>
//         </div>

//         {error && (
//           <div className="p-3 text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg">
//             {error}
//           </div>
//         )}

//         <button
//           type="submit"
//           disabled={isLoading || phoneNumber.length !== 10}
//           className="w-full py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
//         >
//           {isLoading ? (
//             <div className="flex items-center justify-center">
//               <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
//               Sending OTP...
//             </div>
//           ) : (
//             "Send OTP"
//           )}
//         </button>
//       </form>
//     </div>
//   );

//   const renderOTPForm = () => (
//     <div className="w-full max-w-md">
//       <div className="text-center mb-8">
//         <h1 className="text-3xl font-bold text-gray-900 mb-2">Verify OTP</h1>
//         <p className="text-gray-600 mb-4">Enter the 6-digit code sent to</p>
//         <p className="text-blue-600 font-medium">+91 {phoneNumber}</p>
//       </div>

//       <div className="space-y-6">
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-4 text-center">
//             Enter OTP
//           </label>
//           <div className="flex justify-between space-x-2">
//             {otp.map((digit, index) => (
//               <input
//                 key={index}
//                 ref={(el) => (otpRefs.current[index] = el)}
//                 type="text"
//                 value={digit}
//                 onChange={(e) => handleOTPChange(index, e.target.value)}
//                 onKeyDown={(e) => handleOTPKeyDown(index, e)}
//                 className="w-12 h-12 text-center text-xl font-semibold border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
//                 maxLength={1}
//                 disabled={isLoading}
//               />
//             ))}
//           </div>
//         </div>

//         {error && (
//           <div className="p-3 text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg">
//             {error}
//           </div>
//         )}

//         <button
//           onClick={() => handleVerifyOTP()}
//           disabled={isLoading || otp.some((digit) => digit === "")}
//           className="w-full py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
//         >
//           {isLoading ? (
//             <div className="flex items-center justify-center">
//               <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
//               Verifying...
//             </div>
//           ) : (
//             "Verify OTP"
//           )}
//         </button>

//         <div className="text-center space-y-2">
//           {resendTimer > 0 ? (
//             <p className="text-gray-500">Resend OTP in {resendTimer} seconds</p>
//           ) : (
//             <button
//               onClick={handleResendOTP}
//               disabled={isLoading}
//               className="text-blue-600 hover:text-blue-700 font-medium transition-colors"
//             >
//               Resend OTP
//             </button>
//           )}

//           <button
//             onClick={handleBackToLogin}
//             disabled={isLoading}
//             className="block w-full text-gray-500 hover:text-gray-700 transition-colors"
//           >
//             Change mobile number
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
//       <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md">
//         <div className="text-center mb-8">
//           <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
//             <svg
//               className="w-8 h-8 text-blue-600"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
//               />
//             </svg>
//           </div>
//         </div>

//         {authStep === "login" ? renderLoginForm() : renderOTPForm()}

//         <div className="text-center mt-8 text-sm text-gray-500">
//           By continuing, you agree to our Terms of Service and Privacy Policy
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AuthPage;

import React, { useState, useEffect, useCallback, useRef } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate, useLocation, Link } from "react-router-dom";
import Cookies from "js-cookie";
import OtpInput from "react-otp-input";
import Lottie from "lottie-react";

// Import your existing assets and utilities
import SignUpHome from "./assets/SignUpHomeImage.png";
import Logo from "./assets/Group 1261153494.png";
import "./authpage.css";
import APICall from "./Utility/APICall";
import { paths } from "./Utility/Constants";
import { useAuth } from "./Utility/AuthProvider";
import ContinueBtn from "./components/ContinueBtn";
import loaderAnimation from "./assets/animations/loader.json";

// Constants - exactly as in original files
const RESEND_COOLDOWN_SECONDS = 30;
const OTP_COOLDOWN_COOKIE_KEY = "otpCooldownEndTime";
const validateApiUrl =
  "https://renown-backend-assignment.el.r.appspot.com/user/validate";

// Validation schema - exactly as in LoginForm.js
const validationSchema = Yup.object().shape({
  mobileNumber: Yup.string()
    .matches(/^[0-9]*$/, "Mobile number must contain only numbers")
    .length(10, "Mobile number must be exactly 10 digits")
    .required("Mobile number is required"),
});

export default function AuthPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginUser, jwt } = useAuth();

  // Auth flow states
  const [authStep, setAuthStep] = useState("login"); // 'login' | 'otp'

  // Login form states - exactly as in LoginForm.js
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // OTP states - exactly as in OTP.js
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isNewUser, setIsNewUser] = useState(false);
  const [otp, setOtp] = useState("");
  const [resendLoading, setResendLoading] = useState(false);
  const [cooldownTargetTime, setCooldownTargetTime] = useState(0);
  const [resendCooldownDisplay, setResendCooldownDisplay] = useState(0);

  // Redirect path for after successful auth
  const redirectPath = location.state?.from?.pathname || "/dashboard";

  // Debug logs - maintaining original logging
  console.log("AuthPage: Component rendered. Auth Step:", authStep);
  console.log("AuthPage: JWT exists:", !!jwt);

  // Redirect if already authenticated - as in original files
  useEffect(() => {
    if (jwt) {
      console.log(
        "AuthPage: User already authenticated, redirecting to:",
        redirectPath
      );
      navigate(redirectPath, { replace: true });
    }
  }, [jwt, navigate, redirectPath]);

  // Initialize cooldown from cookie - exactly as in OTP.js
  useEffect(() => {
    const cookieCooldownEnd = Cookies.get(OTP_COOLDOWN_COOKIE_KEY);
    let targetTime = 0;

    if (cookieCooldownEnd) {
      const parsedCookieTime = parseInt(cookieCooldownEnd, 10);
      if (parsedCookieTime > Date.now()) {
        targetTime = parsedCookieTime;
        console.log("AuthPage: Cooldown initialized from cookie.");
      } else {
        Cookies.remove(OTP_COOLDOWN_COOKIE_KEY); // Stale cookie
        console.log("AuthPage: Stale cooldown cookie removed.");
      }
    }

    if (targetTime > cooldownTargetTime) {
      setCooldownTargetTime(targetTime);
      console.log("AuthPage: Cooldown target time set:", targetTime);
    }
  }, [cooldownTargetTime]);

  // Cooldown timer effect - exactly as in OTP.js
  useEffect(() => {
    let timerId;
    if (cooldownTargetTime > Date.now()) {
      const updateDisplay = () => {
        const remaining = Math.ceil((cooldownTargetTime - Date.now()) / 1000);
        if (remaining > 0) {
          setResendCooldownDisplay(remaining);
        } else {
          setResendCooldownDisplay(0);
          setCooldownTargetTime(0);
          Cookies.remove(OTP_COOLDOWN_COOKIE_KEY);
          clearInterval(timerId);
          console.log("AuthPage: Cooldown timer naturally expired.");
        }
      };
      updateDisplay();
      timerId = setInterval(updateDisplay, 1000);
    } else {
      setResendCooldownDisplay(0);
      if (cooldownTargetTime > 0) {
        Cookies.remove(OTP_COOLDOWN_COOKIE_KEY);
        setCooldownTargetTime(0);
        console.log("AuthPage: Cooldown cleared.");
      }
    }
    return () => clearInterval(timerId);
  }, [cooldownTargetTime]);

  // Handle phone number submission and OTP sending - exactly as in LoginForm.js
  const handleOnPressContinue = async (values, { setSubmitting }) => {
    const phoneNumber = values.mobileNumber;
    console.log(
      "AuthPage: handleOnPressContinue called with phone:",
      phoneNumber
    );

    setIsLoading(true);
    setErrorMessage("");
    Cookies.remove(OTP_COOLDOWN_COOKIE_KEY); // Clear any old cookie

    const formData = new FormData();
    formData.append("mobile", phoneNumber);

    const requestOptions = {
      method: "POST",
      body: formData,
    };

    try {
      console.log("AuthPage: Validating user with API:", validateApiUrl);
      const response = await fetch(validateApiUrl, requestOptions);
      const result = await response.json();

      console.log("AuthPage: Validation API response:", result);

      if (result.status !== "success") {
        console.warn("AuthPage: Validation failed:", result.message);
        setErrorMessage(result.message || "Validation failed.");
        return;
      }

      let isNewUser = !result.response.is_user;
      console.log("AuthPage: User status - isNewUser:", isNewUser);

      // Signup if new user - exactly as in LoginForm.js
      if (result.response.is_user === false) {
        try {
          console.log("AuthPage: Attempting signup for new user");
          const signupResult = await APICall("POST", paths.user.signup, {
            mobile: phoneNumber,
          });
          console.log("AuthPage: Signup result:", signupResult);

          if (signupResult.status !== "success") {
            console.error("AuthPage: Signup failed:", signupResult.message);
            setErrorMessage(signupResult.message || "Signup failed.");
            return;
          }
          console.log("AuthPage: Signup successful");
        } catch (error) {
          console.error("AuthPage: Error during signup:", error);
          setErrorMessage("An error occurred during signup.");
          return;
        }
      }

      // Send OTP - exactly as in LoginForm.js
      try {
        console.log("AuthPage: Sending OTP");
        const otpResult = await APICall("POST", paths.user.sendOTP, {
          mobile: phoneNumber,
        });

        console.log("AuthPage: OTP send result:", otpResult);

        if (otpResult.status !== "success") {
          console.error("AuthPage: OTP send failed:", otpResult.message);
          setErrorMessage(otpResult.message || "Failed to send OTP.");
          return;
        }

        // Set cooldown and move to OTP step
        const cooldownEndTime = Date.now() + RESEND_COOLDOWN_SECONDS * 1000;
        Cookies.set(OTP_COOLDOWN_COOKIE_KEY, cooldownEndTime.toString(), {
          expires: 1 / 288, // 5 minutes
        });

        console.log("AuthPage: OTP sent successfully, moving to OTP step");
        console.log("AuthPage: Cooldown set until:", new Date(cooldownEndTime));

        // Update state to show OTP form
        setPhoneNumber(phoneNumber);
        setIsNewUser(isNewUser);
        setAuthStep("otp");
        setCooldownTargetTime(cooldownEndTime);
        setErrorMessage("");
      } catch (otpError) {
        console.error("AuthPage: Error sending OTP:", otpError);
        setErrorMessage("An error occurred while sending OTP.");
        return;
      }
    } catch (error) {
      console.error("AuthPage: Error in handleOnPressContinue:", error);
      setErrorMessage("An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
      setSubmitting(false);
      console.log("AuthPage: handleOnPressContinue completed");
    }
  };

  // Handle OTP verification - exactly as in OTP.js
  const handleVerifyAndContinue = async () => {
    console.log("AuthPage: handleVerifyAndContinue called");
    console.log("AuthPage: Phone number:", phoneNumber);
    console.log("AuthPage: OTP length:", otp.length);

    if (!phoneNumber) {
      console.warn("AuthPage: Phone number not found");
      setErrorMessage("Phone number not found. Please restart the process.");
      return;
    }

    if (otp.length < 4) {
      console.warn("AuthPage: Incomplete OTP");
      setErrorMessage("Please enter the complete 4-digit OTP");
      return;
    }

    setIsLoading(true);
    setErrorMessage("");

    try {
      const formData = {
        mobile: phoneNumber,
        otp: otp,
        device_meta: JSON.stringify({ client: "web-app" }),
      };

      console.log("AuthPage: Verifying OTP with data:", formData);
      const result = await APICall("POST", paths.user.login, formData);

      console.log("AuthPage: OTP verification result:", result);

      if (result.status === "success" && result.response) {
        console.log("AuthPage: OTP verification successful");

        // Clear cooldown cookie on successful login - as in OTP.js
        Cookies.remove(OTP_COOLDOWN_COOKIE_KEY);
        console.log("AuthPage: Cooldown cookie cleared on successful login");

        // Set user entity ID cookie - as in OTP.js
        if (result.response.user.entity_id) {
          Cookies.set("user_entity_id", result.response.user.entity_id, {
            expires: 7,
          });
          console.log(
            "AuthPage: User entity ID cookie set:",
            result.response.user.entity_id
          );
        }

        // Login user through context - as in OTP.js
        console.log("AuthPage: Calling loginUser from AuthProvider");
        loginUser("Bearer " + result.response.token, result.response.user);

        // Navigate based on profile completeness - exactly as in OTP.js
        if (
          !result.response.user.first_name ||
          !result.response.user.last_name
        ) {
          console.log(
            "AuthPage: User profile incomplete, redirecting to /add-info"
          );
          navigate("/add-info", { replace: true });
        } else {
          console.log(
            "AuthPage: User profile complete, redirecting to:",
            redirectPath
          );
          navigate(redirectPath, { replace: true });
        }
      } else {
        console.error("AuthPage: OTP verification failed:", result.message);
        setErrorMessage(result.message || "Invalid OTP or login failed.");
      }
    } catch (err) {
      console.error("AuthPage: Error during OTP verification:", err);
      setErrorMessage("An error occurred during verification.");
    } finally {
      setIsLoading(false);
      console.log("AuthPage: handleVerifyAndContinue completed");
    }
  };

  // Handle OTP resend - exactly as in OTP.js
  const handleResendOTP = useCallback(async () => {
    console.log("AuthPage: handleResendOTP called");
    console.log("AuthPage: Resend cooldown display:", resendCooldownDisplay);
    console.log("AuthPage: Resend loading:", resendLoading);
    console.log("AuthPage: Phone number:", phoneNumber);

    if (resendCooldownDisplay > 0 || resendLoading || !phoneNumber) {
      console.log("AuthPage: Resend blocked - conditions not met");
      return;
    }

    setResendLoading(true);
    setErrorMessage("");

    try {
      const formData = { mobile: phoneNumber };
      console.log("AuthPage: Resending OTP with data:", formData);

      const result = await APICall("POST", paths.user.sendOTP, formData);
      console.log("AuthPage: Resend OTP result:", result);

      if (result.status !== "success") {
        console.error("AuthPage: Resend OTP failed:", result.message);
        setErrorMessage(result.message || "Failed to resend OTP.");
      } else {
        const newCooldownEndTime = Date.now() + RESEND_COOLDOWN_SECONDS * 1000;
        setCooldownTargetTime(newCooldownEndTime);
        Cookies.set(OTP_COOLDOWN_COOKIE_KEY, newCooldownEndTime.toString(), {
          expires: 1 / 288,
        });
        setOtp(""); // Clear current OTP
        console.log(
          "AuthPage: OTP resent successfully, new cooldown until:",
          new Date(newCooldownEndTime)
        );
      }
    } catch (err) {
      console.error("AuthPage: Error resending OTP:", err);
      setErrorMessage("An error occurred while resending OTP.");
    } finally {
      setResendLoading(false);
      console.log("AuthPage: handleResendOTP completed");
    }
  }, [phoneNumber, resendCooldownDisplay, resendLoading]);

  // Handle back to login - enhanced with better state cleanup
  const handleBackToLogin = () => {
    console.log("AuthPage: handleBackToLogin called");

    setAuthStep("login");
    setOtp("");
    setErrorMessage("");
    setPhoneNumber("");
    setIsNewUser(false);
    Cookies.remove(OTP_COOLDOWN_COOKIE_KEY);
    setCooldownTargetTime(0);
    setResendCooldownDisplay(0);

    console.log("AuthPage: Returned to login step, all state cleared");
  };

  // Render login form - exactly same UI as LoginForm.js with slight enhancements
  const renderLoginForm = () => (
    <Formik
      initialValues={{ mobileNumber: "" }}
      validationSchema={validationSchema}
      onSubmit={handleOnPressContinue}
    >
      {({ isSubmitting, dirty, isValid, values }) => {
        // Debug log for form state
        console.log("AuthPage: Login form state:", {
          isSubmitting,
          dirty,
          isValid,
          valueLength: values.mobileNumber?.length,
        });

        return (
          <Form>
            <div className="flex flex-col">
              <Field
                as="input"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                className="w-full max-w-sm px-4 py-2 border border-gray-300 rounded-lg shadow-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-300 ease-in-out hover:border-gray-400"
                placeholder="Enter Mobile"
                name="mobileNumber"
                maxLength={10}
                onInput={(e) => {
                  // Only allow numbers - same as original
                  e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  console.log("AuthPage: Mobile number input:", e.target.value);
                }}
              />
              <ErrorMessage
                name="mobileNumber"
                component="div"
                className="error text-red-500 text-xs pt-2"
              />
              {errorMessage && !isLoading && (
                <div className="text-red-500 text-xs pt-2 animate-fade-in">
                  {errorMessage}
                </div>
              )}
              <p
                style={{
                  color: "#1D252D80",
                  paddingBottom: 32,
                  paddingTop: 10,
                }}
              >
                We'll send you an OTP to confirm your number
              </p>
            </div>

            <ContinueBtn
              disabled={isLoading || isSubmitting || !dirty || !isValid}
              type="submit"
            >
              {isLoading || isSubmitting ? (
                <span className="button-spinner"></span>
              ) : (
                "Continue"
              )}
            </ContinueBtn>
          </Form>
        );
      }}
    </Formik>
  );

  // Render OTP form - exactly same UI as OTP.js with slight enhancements
  const renderOTPForm = () => {
    console.log("AuthPage: Rendering OTP form for phone:", phoneNumber);
    console.log("AuthPage: Current OTP:", otp);
    console.log("AuthPage: Resend cooldown:", resendCooldownDisplay);

    return (
      <div>
        <div>
          {/* <p style={{ paddingBottom: 8, fontSize: 24, fontWeight: 600 }}>
            Verify your number
          </p> */}
          <p className="w-96 size-4 flex pb-8">
            Enter the OTP we've sent by SMS to {phoneNumber}:
          </p>
        </div>

        <div className="flex my-8">
          <OtpInput
            value={otp}
            onChange={(value) => {
              setOtp(value);
              console.log(
                "AuthPage: OTP changed:",
                value,
                "Length:",
                value.length
              );
            }}
            numInputs={4}
            containerStyle={{
              width: "auto",
              display: "flex",
              justifyContent: "start",
              gap: "10px",
            }}
            inputStyle={{
              width: "45px",
              height: "45px",
              borderColor: "grey",
              borderWidth: 1,
              borderRadius: 8,
              fontSize: "1.2rem",
              textAlign: "center",
              transition: "border-color 0.2s ease-in-out", // Enhanced: smooth border transition
            }}
            focusStyle={{
              borderColor: "#3B82F6", // Enhanced: blue focus color
              outline: "none",
              boxShadow: "0 0 0 2px rgba(59, 130, 246, 0.2)", // Enhanced: focus glow
            }}
            renderInput={(props) => <input {...props} />}
            shouldAutoFocus
          />
        </div>

        {errorMessage && (
          <p className="text-red-500 text-sm pb-4 animate-fade-in">
            {errorMessage}!!!, Please resend the otp.
          </p>
        )}

        <p className="w-96 pb-10 text-sm">
          Haven't received an OTP?{" "}
          {resendCooldownDisplay > 0 ? (
            <span className="text-gray-500">
              Resend OTP in {resendCooldownDisplay}s
            </span>
          ) : (
            <span
              onClick={handleResendOTP}
              className={`text-blue-600 hover:underline cursor-pointer transition-all duration-200 ${
                resendLoading || resendCooldownDisplay > 0
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:text-blue-700" // Enhanced: hover color change
              }`}
              role="button"
              tabIndex={resendLoading || resendCooldownDisplay > 0 ? -1 : 0}
              onKeyPress={(e) =>
                e.key === "Enter" &&
                !resendLoading &&
                resendCooldownDisplay <= 0 &&
                handleResendOTP()
              }
            >
              {resendLoading ? "Sending..." : "Send again"}
            </span>
          )}
        </p>

        <ContinueBtn
          onClick={handleVerifyAndContinue}
          disabled={isLoading || otp.length < 4}
        >
          {isLoading ? "Verifying..." : "Verify & Continue"}
        </ContinueBtn>

        <p className="pt-4 text-sm">
          <span
            onClick={handleBackToLogin}
            className="text-blue-600 hover:underline cursor-pointer transition-colors duration-200 hover:text-blue-700"
          >
            Change mobile number
          </span>
        </p>
      </div>
    );
  };

  console.log("AuthPage: About to render, auth step:", authStep);

  return (
    <>
      {/* Loading overlay - exactly as in LoginForm.js */}
      {isLoading && (
        <div className="backdrop">
          <div className="spinner-container">
            <Lottie
              animationData={loaderAnimation}
              loop={true}
              style={{ width: 150, height: 150 }}
            />
          </div>
        </div>
      )}

      {/* Main container - exactly same structure as original files */}
      <div className="flex" style={{ height: "100vh" }}>
        {/* Left Side - Branding - exactly as in both original files */}
        <div
          className="part1"
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >
          <div className="part1-img-container">
            <img
              src={SignUpHome}
              height={121}
              width={260}
              alt="RentPe Decoration"
            />
          </div>
          <div>
            <p
              className="px-10"
              style={{ fontSize: 40, fontWeight: 700, color: "white" }}
            >
              <strong>Rent</strong> management made <strong>easy</strong> on{" "}
              <strong>RentPe</strong>
            </p>
          </div>
          <section className="mt-auto w-full text-center p-4 text-white">
            <p className="pb-4">
              <Link to="/privacy-policy">Privacy Policy</Link>
            </p>
            <span>© 2024 RentPe. All rights reserved.</span>
          </section>
        </div>

        {/* Right Side - Auth Forms - exactly same structure as original files */}
        <div
          className="pl-24"
          style={{
            flex: 0.8,
            marginRight: authStep === "otp" ? 20 : 0, // Same margin logic as OTP.js
          }}
        >
          <div className="logo-signup-login pt-36 pb-12">
            <img src={Logo} alt="Logo" width={130} height={130} />
          </div>

          <div>
            <p style={{ paddingBottom: 32, fontSize: 24, fontWeight: 600 }}>
              {authStep === "login" ? "Login / Sign Up" : "Verify your number"}
            </p>
          </div>

          {/* Conditional rendering with smooth transition */}
          <div className="transition-all duration-300 ease-in-out">
            {authStep === "login" ? renderLoginForm() : renderOTPForm()}
          </div>
        </div>
      </div>
    </>
  );
}
